module.exports = __webpack_public_path__ + "nc_static/media/download_kpi.becc8dea.svg";